import { Component } from '@angular/core';

@Component({
  selector: 'smart-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css'],
})
export class FooterComponent {
  date: Date = new Date();
  public copyrightYear = this.date.getFullYear();
}
